import type { SupportToolCall } from '../types';

export const support = (call: SupportToolCall) => {
  const intercom = window.Intercom;
  if (typeof intercom !== 'function') return;

  intercom('show');
  if (call.metadata.space === 'messages') {
    intercom('showNewMessage');
  } else {
    intercom('showSpace', 'help');
  }
};
